import React from "react";
import styles from "./styles.module.css";
const TableSkeleton = ({ columns, rows }) => {
  const skeletonRow = (
    <tr>
      {Array(columns)
        .fill()
        .map((_, index) => (
          <td
            key={index}
            className={{
              padding: "16px 24px",
              borderBottom: "1px solid #E5E7EB",
            }}
          >
            <div className={styles.skeletonStyle}></div>
          </td>
        ))}
    </tr>
  );

  return (
    <>
      <tbody>
        {Array(rows)
          .fill()
          .map((_, index) => (
            <React.Fragment key={index}>{skeletonRow}</React.Fragment>
          ))}
      </tbody>
    </>
  );
};

const DynamicTable = ({
  headers,
  data,
  actions,
  onRowClick,
  title,
  currentPage,
  totalPages,
  onPageChange,
  isLoading,
}) => {
  const handleActionClick = (e, action, row) => {
    e.stopPropagation();
    action.onClick(row);
  };
  return (
    <div className={styles.mainContainer}>
      {title && <div className={styles.title}>{title}</div>}
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              {headers.map((header, index) => (
                <th key={index} className={styles.th}>
                  {header.label}
                </th>
              ))}
              {actions && actions.length > 0 && (
                <th className={styles.th}>Actions</th>
              )}
            </tr>
          </thead>
          {isLoading ? (
            <TableSkeleton
              columns={headers.length + (actions ? 1 : 0)}
              rows={10}
            />
          ) : (
            <tbody>
              {data.map((row, rowIndex) => (
                <tr
                  key={rowIndex}
                  className={styles.row}
                  style={{
                    backgroundColor: rowIndex % 2 === 0 ? "#F9FAFB" : "#FFFFFF",
                  }}
                  onClick={() => onRowClick(row)}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor = "#E5E7EB")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor =
                      rowIndex % 2 === 0 ? "#F9FAFB" : "#FFFFFF")
                  }
                >
                  {headers.map((header, cellIndex) => (
                    <td
                      key={cellIndex}
                      className={styles.td}
                      data-label={header.label} // Add this line for responsive labels
                    >
                      {header.key === "patient_id" ? (
                        <div className={styles.avatarName}>
                          {row.avatar && (
                            <img
                              src={row.avatar}
                              alt={row.patient_id[1]}
                              className={styles.avatar}
                            />
                          )}
                          <span>{row.patient_id[1]}</span>
                        </div>
                      ) : (
                        row[header.key]
                      )}
                    </td>
                  ))}
                  {actions && actions.length > 0 && (
                    <td className={styles.actionButtons}>
                      {actions.map((action, actionIndex) =>
                        action.showIf && action.showIf(row) ? (
                          <button
                            key={actionIndex}
                            onClick={(e) => handleActionClick(e, action, row)}
                            className={styles.actionButton} // Ensure this class is applied
                          >
                            {action.label}
                          </button>
                        ) : null
                      )}
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          )}
        </table>
      </div>
      {data.length > 0 && !isLoading && (
        <div className={styles.pagination}>
          <button
            className={styles.pageButton}
            style={{
              opacity: currentPage === 1 ? 0.5 : 1,
            }}
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <span className={styles.pageInfo}>
            Page {currentPage} of {totalPages}
          </span>
          <button
            className={styles.pageButton}
            style={{
              opacity: currentPage === totalPages ? 0.5 : 1,
            }}
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default DynamicTable;
